import { Directive, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NotificationService } from '@shared/services/notification.service';

@Directive({
	selector: '[OnlyPattern]',
	standalone: false,
})
export class OnlyRegexPatternDirective implements OnChanges {
	@Input('OnlyPattern') pattern: string | RegExp; // Default value

	private _pattern: RegExp;

	constructor(private notification: NotificationService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['pattern']) {
			const value = changes['pattern'].currentValue;

			if (value instanceof RegExp) {
				this._pattern = value;
			} else {
				this._pattern = new RegExp(value);
			}
		}
	}

	@HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
		if (event instanceof ClipboardEvent) {
			const clipboardData = event.clipboardData.getData('text/plain');
			if (clipboardData) {
				if (!this._pattern.test(clipboardData)) {
					event.preventDefault();
					this.notification.notify(['general.validation.pattern.paste.notification.header'], ['general.validation.pattern.paste.notification.content'], 'error');
				}
			}
		}
	}

	@HostListener('keypress', ['$event'])
	OnkeyPress(e: KeyboardEvent) {
		// Build the new value as if the key is accepted
		const input = e.target as HTMLInputElement;
		const currentValue = input.value;
		const selectionStart = input.selectionStart ?? currentValue.length;
		const selectionEnd = input.selectionEnd ?? currentValue.length;
		const newChar = e.key;
		// Simulate the new value as if the key is accepted
		const newValue = currentValue.slice(0, selectionStart) + newChar + currentValue.slice(selectionEnd);

		// Check if the new value matches the pattern
		if (this._pattern.test(newValue)) {
			return true;
		}
		e.preventDefault();
		return false;
	}
}
